import { StudentExamType } from '../../api/student-exam';
import Field from '../shared/field';
import { BLANK_TEXT } from '../../utils';
import Segment from '../shared/segment';
import Section from '../shared/section';
import NavLink from '../shared/buttons/nav-link';

export type StuedentExamPropsType = {
  studentExam: StudentExamType;
};

function StudentExam({ studentExam }: StuedentExamPropsType) {
  return (
    <Segment
      hoverable
      noPad
      color={studentExam.status === 2 ? 'green' : 'yellow'}
      rounded='2xl'
      className='flex flex-col'
    >
      <Section>
        <p className='text-center font-medium'>{studentExam.exam.name}</p>
      </Section>
      <Section className='flex flex-col gap-2'>
        <Field title='زمان آزمون' content={`${studentExam.exam.duration} دقیقه`} />
        <Field title='تعداد سوالات' content={studentExam.exam.questionCount} />
        <Field title='نمره منفی' content={studentExam.exam.penalty ? 'دارد' : 'ندارد'} />
      </Section>
      <Section className='flex flex-col gap-2'>
        <Field title='وضعیت' content={studentExam.status === 2 ? 'شرکت کرده' : 'منقضی شده'} />
        <Field title='تعداد جواب‌های درست' content={studentExam.correctQuestionCount} />
        <Field
          title='تعداد جواب‌های سفید'
          content={
            studentExam.exam.questionCount -
            studentExam.correctQuestionCount -
            studentExam.wrongQuestionCount
          }
        />
        <Field title='تعداد جواب‌های نادرست' content={studentExam.wrongQuestionCount} />
      </Section>
      <Section className='flex flex-col gap-2'>
        <Field
          ltr
          title='زمان شروع آزمون'
          content={
            studentExam.started &&
            new Date(studentExam.started)
              .toLocaleDateString('fa-IR', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
              })
              .replace(',', '')
          }
        />
        <Field
          ltr
          title='مدت آزمون'
          content={studentExam.duration?.substring(0, studentExam.duration.indexOf('.'))}
        />
        <Field
          ltr
          title='نتیجه'
          content={studentExam.result ? `${studentExam.result}%` : BLANK_TEXT}
        />
        <Field title='رتبه' content={studentExam.rank || BLANK_TEXT} />
        {studentExam.exam.isExpired && (
          <Field
            ltr
            title='تراز'
            content={
              studentExam.normalizedResult ||
              (studentExam.status === 2 ? 'محاسبه بعد از اتمام آزمون' : BLANK_TEXT)
            }
          />
        )}
        <Field title='تعداد شرکت کنندگان تاکنون' content={studentExam.exam.studentFinishedCount} />
      </Section>
      <div className='my-4 mx-auto flex gap-2 text-center'>
        <NavLink
          to={`/review/exams/${studentExam.exam.id}`}
          color='green'
          content='تحلیل آزمون'
          className='mx-auto'
        />
        {studentExam.exam.lessonCount > 1 && (
          <NavLink
            to={`/report/exams/${studentExam.exam.id}`}
            color='indigo'
            content='کارنامه تحلیلی'
            className='mx-auto'
          />
        )}
      </div>
    </Segment>
  );
}

export default StudentExam;
